import React from 'react';
import Table from '../../../../components/_table/Table';
import { columns } from './columns';
import { COUPON_BRAND_ITEM_LIST_FILTER_OPTION_MODEL } from '../../../../store/modules/coupon/models';
import { _LIST_PAGINATION_MODEL } from '../../../../store/modules/app/models';
import './CouponDetailBrandItemList.scss';

const CouponDetailBrandItemList = (props) => {
  const { couponBrandLinkList, getList, filterOption, pagination, toggleModal, couponInfo } = props;

  return (
    <div className="coupon-detail-brand-item-content">
      <Table
        className="coupon-detail-brand-item-list"
        columns={(utils) =>
          columns({
            ...utils,
            isFilter: true,
            toggleModal,
            minimumPurchasePrice: couponInfo.minimumPurchasePrice,
            discountAmount: couponInfo.discountAmount,
            discountType: couponInfo.discountType,
            maxDiscountPrice: couponInfo.maxDiscountPrice,
            exclude24k: couponInfo.exclude24k,
          })
        }
        rowKey={(record) => record.id}
        list={couponBrandLinkList}
        initialOption={{
          filterOption: COUPON_BRAND_ITEM_LIST_FILTER_OPTION_MODEL,
          pagination: _LIST_PAGINATION_MODEL,
        }}
        filterOption={filterOption}
        pagination={pagination}
        size="small"
        scroll={{ x: true }}
        bordered={true}
        getList={(option) =>
          getList({
            ...option,
          })
        }
      />
    </div>
  );
};

export default CouponDetailBrandItemList;
